// Handle variant add to cart forms in product cards
document.addEventListener('DOMContentLoaded', () => {
  initVariantForms();
  observeNewForms();
});

// Also init on dynamic content load
if (typeof window.initVariantForms === 'undefined') {
  window.initVariantForms = initVariantForms;
}

function initVariantForms() {
  const variantForms = document.querySelectorAll('[data-variant-form]');
  
  variantForms.forEach(form => {
    // Remove any existing listeners to prevent duplicates
    if (form._variantFormInitialized) return;
    form._variantFormInitialized = true;

    form.addEventListener('submit', handleVariantFormSubmit);
  });
}

// Watch for dynamically added forms
function observeNewForms() {
  const observer = new MutationObserver(() => {
    initVariantForms();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

async function handleVariantFormSubmit(event) {
  event.preventDefault();
  
  const form = event.target;
  const submitButton = form.querySelector('button[type="submit"]');
  const cartDrawer = document.querySelector('cart-drawer');
  
  // Disable button during submission
  if (submitButton) {
    submitButton.setAttribute('disabled', '');
    submitButton.classList.add('loading');
  }
  
  try {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    
    const formData = new FormData(form);
    
    // Add sections to refresh if cart drawer exists
    if (cartDrawer) {
      formData.append(
        'sections',
        cartDrawer
          .getSectionsToRender()
          .map(section => section.section)
      );
      formData.append('sections_url', window.location.pathname);
    }
    
    config.body = formData;
    
    const response = await fetch(`${routes.cart_add_url}`, config);
    const responseData = await response.json();
    
    if (responseData.status || responseData.errors) {
      // Handle error
      console.error('Error adding to cart:', responseData.message || responseData.errors);
      return;
    }
    
    // Update cart drawer
    if (cartDrawer) {
      cartDrawer.renderContents(responseData);
    }
    
    // Update cart counters
    if (typeof updateCartCounters === 'function') {
      updateCartCounters();
    }
    
  } catch (error) {
    console.error('Error adding to cart:', error);
  } finally {
    // Re-enable button
    if (submitButton) {
      submitButton.removeAttribute('disabled');
      submitButton.classList.remove('loading');
    }
  }
}

